export default ['C0000012719', 'C0000022679', 'C0000023917', 'C0000025325', 'C0000024995'];